const KEY = 'debug'

interface DebugFn {
  (formatter: string, ...args: any[]): void
  warn: (formatter: string, ...args: any[]) => void
  error: (formatter: string, ...args: any[]) => void
}

export function createDebugger(namespace: string): DebugFn {
  const enabled = () => {
    if ((window as any).__DEBUG)
      return true
    const val = localStorage.getItem(KEY)
    if (!val)
      return false
    return val === '*' || val.split(',').map(s => s.trim()).includes(namespace)
  }

  const fn = ((formatter: string, ...args: any[]) => {
    if (!enabled())
      return
    // eslint-disable-next-line no-console
    console.log(`[${namespace}]`, formatter, ...args)
  }) as DebugFn

  fn.warn = (formatter: string, ...args: any[]) => {
    if (!enabled())
      return

    console.warn(`[${namespace}]`, formatter, ...args)
  }

  fn.error = (formatter: string, ...args: any[]) => {
    if (!enabled())
      return

    console.error(`[${namespace}]`, formatter, ...args)
  }

  return fn
}
